module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_Frame02-ee28fafdf7c1e1ba13645563e405524e.png";